import { IRowNode } from 'ag-grid-community';
import { SignatureRow } from 'components/tables/data/signature/types';
import SignatureActions from 'components/tables/data/signature/SignatureActions';
import { useSignatureTableContext } from 'components/tables/data/signature/SignatureTable';

/**
 * Column for the actions.
 */
export default function ActionsColumn({ node, data }: { node: IRowNode<SignatureRow>; data: SignatureRow }) {
  const { onStatusChange, onNoLongerAccessible } = useSignatureTableContext();

  return (
    <SignatureActions
      signature={data}
      compactOnTablet
      onStatusChange={({ status }) => onStatusChange({ kepMessageUuid: data.kepMessageUuid, status })}
      onNoLongerAccessible={onNoLongerAccessible}
    />
  );
}
